import React, { useEffect } from "react";
import { Dialog, DialogContent } from "../ui/dialog";
import { Button } from "../ui/button";
import { motion } from "framer-motion";
import { BADGE_ICONS, bigCelebrate } from "../../lib/engage";
import { Award } from "lucide-react";

export const BadgeUnlockModal = ({ badges, open, onClose }) => {
  useEffect(() => {
    if (open && badges?.length) bigCelebrate();
  }, [open, badges]);

  if (!open || !badges?.length) return null;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="badge-unlock-modal" className="bg-slate-900 border-emerald-500/40 text-slate-100 max-w-md text-center">
        <p className="text-xs font-semibold uppercase tracking-widest text-emerald-400 mt-2">Badge unlocked!</p>
        <h2 className="font-heading text-3xl font-bold text-slate-50">
          {badges.length > 1 ? `${badges.length} new badges` : "New badge earned"}
        </h2>
        <div className="flex flex-wrap justify-center gap-4 my-4">
          {badges.map((b, i) => {
            const Icon = BADGE_ICONS[b.icon] || Award;
            return (
              <motion.div
                key={b.id}
                initial={{ scale: 0, rotate: -20 }}
                animate={{ scale: 1, rotate: 0 }}
                transition={{ type: "spring", stiffness: 260, damping: 14, delay: i * 0.12 }}
                className="w-40"
              >
                <div className="w-20 h-20 mx-auto rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center shadow-lg shadow-emerald-500/30">
                  <Icon className="w-10 h-10 text-slate-950" strokeWidth={2} />
                </div>
                <p className="font-heading font-bold text-slate-100 mt-2">{b.name}</p>
                <p className="text-xs text-slate-400 mt-0.5">{b.description}</p>
              </motion.div>
            );
          })}
        </div>
        <Button
          data-testid="badge-modal-close"
          onClick={onClose}
          className="w-full h-11 bg-gradient-to-r from-emerald-500 to-teal-600 text-slate-950 font-bold"
        >
          Keep growing
        </Button>
      </DialogContent>
    </Dialog>
  );
};
